@if(currentSection === 'summary'){
<div class="py-200-rem px-250-rem h-full" data-testid="summary">
  <div class="flex flex-col space-y-050-rem">
    <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Summary</h1>
    <div class="text-container-fg-muted text-label-md-weight-regular max-w-2xl">
      Review the rollout plan settings.
    </div>
  </div>

  <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default gap-4 container flex flex-col">
    <div>
      <h3 class="text-headline-sm-weight-medium text-[1.125rem] text-container-fg-default">
        Plan details
      </h3>
      <div class="flex items-center gap-x-050-rem py-050-em">
        <i
          class="icon_marina_ui_InfoOutlined text-container-fg-muted text-headline-sm"
          aria-hidden="true"></i>
        <p class="text-container-fg-muted text-body-lg-weight-regular w-2xl">
          Information on compatible device software versions is inherited from the selected firmware
          package (read-only).
        </p>
      </div>
    </div>
    <p class="text-label-lg-weight-medium text-container-fg-default">
      Firmware package to roll out
    </p>
    <div>
      <h3 class="text-label-sm-weight-regular text-container-fg-muted">
        Firmware package bundle version
      </h3>
      <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
        {{ allFormData().planDetails.firmware_package_bundle_version }}
      </p>
    </div>

    <div>
      <h4 class="text-label-lg-weight-medium text-container-fg-default py-100-em">
        Compatible device software versions
      </h4>
      <div class="grid grid-cols-2 gap-y-8">
        @for(version of formatCompatibleVersions(); track version){
        <div class="flex items-center gap-100-em">
          <div class="text-body-md-weight-regular text-container-fg-muted">CP</div>
          <div>
            <p class="text-label-sm-weight-regular text-container-fg-muted">
              Compatible device software versions
            </p>

            <p class="text-body-lg-weight-regular text-container-fg-default">{{version}}</p>
          </div>
        </div>
        }
      </div>
    </div>
  </div>

  <div
    class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default container gap-2 flex flex-col">
    @if(allFormData().distributionSettings.strategy.strategyType === "Percentage"){
    <h2 class="text-headline-sm-weight-medium text-[1.125rem] text-container-fg-default pb-075-rem">
      Target product groups & rollout percentages
    </h2>
    @for (productGroup of productGroupsWithPercentages(); track productGroup.name) {
    <div class="flex justify-between w-lg space-y-200-rem">
      <div>
        <p class="text-label-sm-weight-regular text-container-fg-muted">Target product</p>
        <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
          {{ productGroup.name }}
        </p>
      </div>
      <div>
        <p class="text-label-sm-weight-regular text-container-fg-muted">Rollout percentage [%]</p>
        <p class="text-body-lg-weight-regular text-[1rem] text-container-fg-default">
          {{ productGroup.percentage }}
        </p>
      </div>
    </div>
    } } @else {

    <h2 class="text-headline-sm-weight-medium text-[1.125rem] text-container-fg-default pb-075-rem">
      Devices to roll out to
    </h2>
    <table mat-table [dataSource]="dataSource" class="full-width-table" aria-label="Elements">
      <ng-container matColumnDef="targetProductGroups">
        <th mat-header-cell *matHeaderCellDef>TARGET PRODUCT GROUPS</th>
        <td mat-cell *matCellDef="let element">{{element.name}}</td>
      </ng-container>

      <ng-container matColumnDef="btFriendlyNames">
        <th mat-header-cell *matHeaderCellDef>BT-FRIENDLY NAME(S) OF DEVICE(S)</th>
        <td mat-cell *matCellDef="let element">
          @if (element.btFriendlyNames.length > 0) { @for (name of element.btFriendlyNames; track
          name) {
          <div>{{ name }}</div>
          } } @else {
          <span>-</span>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    }
  </div>
  <shared-domain-app-distribution
    [formattedAccess]="formattedAccess()"
    [distributionDetails]="$safeNavigationMigration(firmwarePackageDetails()?.distribution?.supportedCompanionApps)">
  </shared-domain-app-distribution>
</div>
}
